
const m = window.require("discourse/helpers/period-title");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
